import {
  HoverCardProps as MantineHoverCardProps,
  HoverCard as MantineHoverCard,
  HoverCardTargetProps as MantineHoverCardTargetProps,
  HoverCardTarget as MantineHoverCardTarget,
  HoverCardDropdownProps as MantineHoverCardDropdownProps,
  HoverCardDropdown as MantineHoverCardDropdown,
} from '@mantine/core';

export type HoverCardProps = MantineHoverCardProps;
export type HoverCardTargetProps = MantineHoverCardTargetProps;
export type HoverCardDropdownProps = MantineHoverCardDropdownProps;

export const HoverCard = MantineHoverCard;
HoverCard.displayName = 'HoverCard';

export const HoverCardTarget = MantineHoverCardTarget;
HoverCardTarget.displayName = 'HoverCardTarget';

export const HoverCardDropdown = MantineHoverCardDropdown;
HoverCardDropdown.displayName = 'HoverCardDropdown';
